import { VARIABLES } from '@features/reminders/data/index.data';
import { extractVariablesFromContent } from '@shared/features/reminders/helpers/extract-variables-from-content';

export const syncVariablesFromContent = (
  content: string,
  setFieldValue: (field: string, value: Record<string, string>) => void
) => {
  const foundVariables = extractVariablesFromContent(content);
  const syncedVariables: Record<string, string> = {};

  foundVariables.forEach((variableName) => {
    const variableDef = VARIABLES.find((v) => v.value === variableName);
    if (variableDef) {
      syncedVariables[variableName] = variableDef.example;
    }
  });

  setFieldValue('variables', syncedVariables);
};
